<div class="ggc-dl-legend-img">
  <img [src]="legend.legendUrl" [alt]="layerName" />
</div>
